export default function prefixReducer(prefix, action) {
  switch (action.type) {
    case "set":
      return action.value;

    default:
      return { ...prefix, [action.type]: action.value };
  }
}
